import React from 'react'
import { SkeletorApplicationLinkWithTooltip } from '../../application-tooltip'
import { ServerEnvironment } from '../../servers-grid/shared'
import { UrlWithTooltip } from './url-with-tooltip'
import { ServerLinkWithTooltip } from './server-link-with-tooltip'

interface TargetCellProps {
  organizationID: string
  rowData: {
    application: {
      id: string
      name: string
    }
    server: {
      id: string
      name: string
      environment: ServerEnvironment
    }
    url?: string
  }
}

export function TargetCell({
  organizationID,
  rowData: { application, server, url }
}: TargetCellProps) {
  return (
    <div>
      <SkeletorApplicationLinkWithTooltip
        organizationUuid={organizationID}
        applicationUuid={application.id}
        applicationName={application.name}
        placement="left"
        showAttackStatus={false}
        truncate
        showLabel
      />
      <ServerLinkWithTooltip
        organizationUuid={organizationID}
        serverUuid={server.id}
        serverEnvironment={server.environment}
        serverName={server.name}
        truncate
        placement="left"
      />
      {!!url && <UrlWithTooltip url={url} placement="left" />}
    </div>
  )
}
